export function formatString(dateTimeString = null, options = {}) {
  const { hours = 0, minutes = 0, showTime = 0, format = null } = options;
  let d = dateTimeString
    ? new Date(stripMillisecondsAndZ(dateTimeString))
    : new Date();
  if (!dateTimeString) {
    const year = d.getUTCFullYear();
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const day = String(d.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  } else return formatDate(d, format || "YYYY-MM-DD HH:mm");
}

function formatDate(dateInput, format = "YYYY-MM-DD HH:mm") {
  const d = new Date(dateInput);

  const map = {
    YYYY: d.getFullYear(),
    MM: String(d.getMonth() + 1).padStart(2, "0"),
    DD: String(d.getDate()).padStart(2, "0"),
    HH: String(d.getHours()).padStart(2, "0"),
    mm: String(d.getMinutes()).padStart(2, "0"),
    ss: String(d.getSeconds()).padStart(2, "0"),
  };
  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (match) => map[match]);
}

function stripMillisecondsAndZ(dateString) {
  return dateString.replace(/\.\d{3}Z$/, "");
}
